import React, { useContext } from 'react'
import { ContentInner } from '../../../../../layout/Content'
import PrinterSettingsStyle from '../../../../../../css/PrinterSettingsStyle'
import LogsInnerStyle from './css/LogsInnerStyle'
import { logsControllerContext } from './LogsController'

function LogsInner(props) {
  const logsController = useContext(logsControllerContext)
  const logs = logsController.logs[0]

  const { app } = logsController

  return (
    <ContentInner>
      <div className='report-wrapper'>
        <div className='logs-report-container printable'>
          <h3>System's Logs</h3>
          <div className='dates-header-container'>
            <div>As of {new Date(app.getClientDateTime()).toLocaleString("en-us")} { app.getClientTimezone() }</div>
          </div>
          <br />
          <div>
            {
              logs
              ? logs.map((log, i) => (
                  <div key={i}>
                    {i+1}. {new Date(log.date_and_time).toLocaleString('en-Us', { timeZone: log._client_timezone })} { log.client_timezone } {log.url} <i>{log.details}</i> {log.committed_by}
                  </div>
                ))
              : null
            }
          </div>
        </div>
      </div>
      <LogsInnerStyle />
      <PrinterSettingsStyle paperWidth='8.5inch'/>
    </ContentInner>
  )
}

export default React.memo(LogsInner)
